import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import moment from 'moment';

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";
import { formatNullable } from "../../../../../../common/src/util/dataUtil";
import config from "../../../../../../server/src/config";

import * as AdminActions from "../../../../actions/admin";
import {hasCommonProps} from "../../../../utils/Util";

export const defaultState = {
    A_Klasse1: '0',
    A_Klasse2: '0',
    A_Klasse3: '0',
    A_Klasse4: '0',
    A_Klasse5: '0',
    A_Klasse6: '0',
    B_Klasse1: '0',
    B_Klasse2: '0',
    B_Klasse3: '0',
    B_Klasse4: '0',
    B_Klasse5: '0',
    B_Klasse6: '0',
    KL_P: '0',
    KL_E: '0',
    Slagspil:'0',
    KL_Z: '0',
    KL_R: '0',
    Derby: '0',
    TillaegFastForening: '0',
    TillaegPrDueForening: '0',
};

class SettingsDeposits extends React.Component {

    static propTypes = {
        editMode: PropTypes.bool,
        section: PropTypes.object.isRequired,
        sectionNo: PropTypes.string.isRequired,
        isDDB: PropTypes.bool.isRequired,
        isSection: PropTypes.bool.isRequired,
        isClub: PropTypes.bool.isRequired,
    };

    static defaultProps = {
        editMode: false,
    };

    constructor(props) {
        super(props);
        this.state = Object.assign({}, this.getStateFromStore(props));
    }

    componentWillReceiveProps(nextProps) {
        if(!nextProps.editMode || ((nextProps.section === null && this.props.section !== null) || (nextProps.section !== null && (this.props.section === null || this.props.sectionNo !== nextProps.sectionNo)))) this.setState(this.getStateFromStore(nextProps));
    }

    getStateFromStore(props) {
        if (props.section.Indskud === null)
            return defaultState;
        else {
            const deposit = props.section.Indskud;
            return {
                A_Klasse1:            deposit.A_Klasse1            === null ? '0': deposit.A_Klasse1.toString(),
                A_Klasse2:            deposit.A_Klasse2            === null ? '0': deposit.A_Klasse2.toString(),
                A_Klasse3:            deposit.A_Klasse3            === null ? '0': deposit.A_Klasse3.toString(),
                A_Klasse4:            deposit.A_Klasse4            === null ? '0': deposit.A_Klasse4.toString(),
                A_Klasse5:            deposit.A_Klasse5            === null ? '0': deposit.A_Klasse5.toString(),
                A_Klasse6:            deposit.A_Klasse6            === null ? '0': deposit.A_Klasse6.toString(),
                B_Klasse1:            deposit.B_Klasse1            === null ? '0': deposit.B_Klasse1.toString(),
                B_Klasse2:            deposit.B_Klasse2            === null ? '0': deposit.B_Klasse2.toString(),
                B_Klasse3:            deposit.B_Klasse3            === null ? '0': deposit.B_Klasse3.toString(),
                B_Klasse4:            deposit.B_Klasse4            === null ? '0': deposit.B_Klasse4.toString(),
                B_Klasse5:            deposit.B_Klasse5            === null ? '0': deposit.B_Klasse5.toString(),
                B_Klasse6:            deposit.B_Klasse6            === null ? '0': deposit.B_Klasse6.toString(),
                KL_P:                 deposit.KL_P                 === null ? '0': deposit.KL_P.toString(),
                KL_E:                 deposit.KL_E                 === null ? '0': deposit.KL_E.toString(),
                Slagspil:             deposit.Slagspil             === null ? '0': deposit.Slagspil.toString(),
                KL_Z:                 deposit.KL_Z                 === null ? '0': deposit.KL_Z.toString(),
                KL_R:                 deposit.KL_R                 === null ? '0': deposit.KL_R.toString(),
                Derby:                deposit.Derby                === null ? '0': deposit.Derby.toString(),
                TillaegFastForening:  deposit.TillaegFastForening  === null ? '0': deposit.TillaegFastForening.toString(),
                TillaegPrDueForening: deposit.TillaegPrDueForening === null ? '0': deposit.TillaegPrDueForening.toString(),
            }
        }
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    save = (onSuccess = null) => {
        if (this.allInputValid()) {
            const entity = this.props.isClub ? {
                TillaegFastForening:   this.state.TillaegFastForening  === null ? 0: Number(this.state.TillaegFastForening),
                TillaegPrDueForening:  this.state.TillaegPrDueForening === null ? 0: Number(this.state.TillaegPrDueForening),
            } : {
                A_Klasse1:             this.state.A_Klasse1            === null ? 0: Number(this.state.A_Klasse1),
                A_Klasse2:             this.state.A_Klasse2            === null ? 0: Number(this.state.A_Klasse2),
                A_Klasse3:             this.state.A_Klasse3            === null ? 0: Number(this.state.A_Klasse3),
                A_Klasse4:             this.state.A_Klasse4            === null ? 0: Number(this.state.A_Klasse4),
                A_Klasse5:             this.state.A_Klasse5            === null ? 0: Number(this.state.A_Klasse5),
                A_Klasse6:             this.state.A_Klasse6            === null ? 0: Number(this.state.A_Klasse6),
                B_Klasse1:             this.state.B_Klasse1            === null ? 0: Number(this.state.B_Klasse1),
                B_Klasse2:             this.state.B_Klasse2            === null ? 0: Number(this.state.B_Klasse2),
                B_Klasse3:             this.state.B_Klasse3            === null ? 0: Number(this.state.B_Klasse3),
                B_Klasse4:             this.state.B_Klasse4            === null ? 0: Number(this.state.B_Klasse4),
                B_Klasse5:             this.state.B_Klasse5            === null ? 0: Number(this.state.B_Klasse5),
                B_Klasse6:             this.state.B_Klasse6            === null ? 0: Number(this.state.B_Klasse6),
                KL_P:                  this.state.KL_P                 === null ? 0: Number(this.state.KL_P),
                KL_E:                  this.state.KL_E                 === null ? 0: Number(this.state.KL_E),
                Slagspil:              this.state.Slagspil             === null ? 0: Number(this.state.Slagspil),
                KL_Z:                  this.state.KL_Z                 === null ? 0: Number(this.state.KL_Z),
                KL_R:                  this.state.KL_R                 === null ? 0: Number(this.state.KL_R),
            };

            if(this.props.isDDB) {
                entity.Derby = this.state.Derby === null ? null : Number(this.state.Derby);
            }

            // Creating new row or updating existing
            if(!this.props.section.Indskud){
                this.props.dispatch(AdminActions.createDeposit(this.props.isDDB ? 'ddb' : this.props.isSection ? this.props.section.Sektionsnr : this.props.section.Foreningsnr, entity, onSuccess))
            } else {
                this.props.dispatch(AdminActions.updateDeposit(this.props.isDDB ? 'ddb' : this.props.isSection ? this.props.section.Sektionsnr : this.props.section.Foreningsnr, entity, onSuccess));
            }
        } else {
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }
    }

    fields = [];
    render() {
        const editMode = this.props.editMode;
        return <React.Fragment>
        <div className={"form-page flex-center " + (editMode ? "editable" : "read-only")}>
            <table className="main-form-table deposit-table">
                <tbody>
                    <tr>
                        <td className={"label-cell"}><span className="label-text"><label className={"deposit-header"}>A-Spil</label></span></td>
                    </tr>
                    <tr>
                        {this.props.isClub ? <td className={"label-cell"}><span className="label-text"><label htmlFor="A_Klasse1">&nbsp;</label></span></td> : null}
                        <td className={"label-cell"}><span className="label-text"><label htmlFor="A_Klasse1">Kl. 1</label></span></td>
                        <td className={"label-cell"}><span className="label-text"><label htmlFor="A_Klasse2">Kl. 2</label></span></td>
                        <td className={"label-cell"}><span className="label-text"><label htmlFor="A_Klasse3">Kl. 3</label></span></td>
                        <td className={"label-cell"}><span className="label-text"><label htmlFor="A_Klasse4">Kl. 4</label></span></td>
                        <td className={"label-cell"}><span className="label-text"><label htmlFor="A_Klasse5">Kl. 5</label></span></td>
                        <td className={"label-cell"}><span className="label-text"><label htmlFor="A_Klasse6">Kl. 6</label></span></td>
                    </tr>
                    <tr className={this.props.isClub ? "" : "normal-row"}>
                        {this.props.isClub ? <td className={"label-cell"}><span className="label-text">DdB</span></td> : null}
                        <td className={"data-cell"}>
                            {editMode && !this.props.isClub ?
                                <UserFieldElement
                                    dataType={UserFieldDataType.regex}
                                    placeholder=""
                                    className="field-1 "
                                    containerClassName="display-inline-block"
                                    name="A_Klasse1"
                                    id="A_Klasse1"
                                    value={this.state.A_Klasse1}
                                    maxLength="5"
                                    options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{0,5}"}]}
                                    autoCheckErrors={true}
                                    required={false}
                                    hideErrWhenFocused={true}
                                    hideErrUntilFocused={true}
                                    onChange={this.onStandardFieldChange}
                                    ref={instance => { this.fields[1] = instance; }}
                                />
                                : <span className="value-text">{this.props.isClub ? this.props.admin.generalSection.Indskud.A_Klasse1 : this.state.A_Klasse1}</span>}
                        </td>
                        <td className={"data-cell"}>
                            {editMode && !this.props.isClub ?
                                <UserFieldElement
                                    dataType={UserFieldDataType.regex}
                                    placeholder=""
                                    className="field-1 "
                                    containerClassName="display-inline-block"
                                    name="A_Klasse2"
                                    id="A_Klasse2"
                                    value={this.state.A_Klasse2}
                                    maxLength="5"
                                    options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{0,5}"}]}
                                    autoCheckErrors={true}
                                    required={false}
                                    hideErrWhenFocused={true}
                                    hideErrUntilFocused={true}
                                    onChange={this.onStandardFieldChange}
                                    ref={instance => { this.fields[2] = instance; }}
                                />
                                : <span className="value-text">{this.props.isClub ? this.props.admin.generalSection.Indskud.A_Klasse2 : this.state.A_Klasse2}</span>}
                        </td>
                        <td className={"data-cell"}>
                            {editMode && !this.props.isClub ?
                                <UserFieldElement
                                    dataType={UserFieldDataType.regex}
                                    placeholder=""
                                    className="field-1 "
                                    containerClassName="display-inline-block"
                                    name="A_Klasse3"
                                    id="A_Klasse3"
                                    value={this.state.A_Klasse3}
                                    maxLength="5"
                                    options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{0,5}"}]}
                                    autoCheckErrors={true}
                                    required={false}
                                    hideErrWhenFocused={true}
                                    hideErrUntilFocused={true}
                                    onChange={this.onStandardFieldChange}
                                    ref={instance => { this.fields[3] = instance; }}
                                />
                                : <span className="value-text">{this.props.isClub ? this.props.admin.generalSection.Indskud.A_Klasse3 : this.state.A_Klasse3}</span>}
                        </td>
                        <td className={"data-cell"}>
                            {editMode && !this.props.isClub ?
                                <UserFieldElement
                                    dataType={UserFieldDataType.regex}
                                    placeholder=""
                                    className="field-1 "
                                    containerClassName="display-inline-block"
                                    name="A_Klasse4"
                                    id="A_Klasse4"
                                    value={this.state.A_Klasse4}
                                    maxLength="5"
                                    options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{0,5}"}]}
                                    autoCheckErrors={true}
                                    required={false}
                                    hideErrWhenFocused={true}
                                    hideErrUntilFocused={true}
                                    onChange={this.onStandardFieldChange}
                                    ref={instance => { this.fields[4] = instance; }}
                                />
                                : <span className="value-text">{this.props.isClub ? this.props.admin.generalSection.Indskud.A_Klasse4 : this.state.A_Klasse4}</span>}
                        </td>
                        <td className={"data-cell"}>
                            {editMode && !this.props.isClub ?
                                <UserFieldElement
                                    dataType={UserFieldDataType.regex}
                                    placeholder=""
                                    className="field-1 "
                                    containerClassName="display-inline-block"
                                    name="A_Klasse5"
                                    id="A_Klasse5"
                                    value={this.state.A_Klasse5}
                                    maxLength="5"
                                    options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{0,5}"}]}
                                    autoCheckErrors={true}
                                    required={false}
                                    hideErrWhenFocused={true}
                                    hideErrUntilFocused={true}
                                    onChange={this.onStandardFieldChange}
                                    ref={instance => { this.fields[5] = instance; }}
                                />
                                : <span className="value-text">{this.props.isClub ? this.props.admin.generalSection.Indskud.A_Klasse5 : this.state.A_Klasse5}</span>}
                        </td>
                        <td className={"data-cell"}>
                            {editMode && !this.props.isClub ?
                                <UserFieldElement
                                    dataType={UserFieldDataType.regex}
                                    placeholder=""
                                    className="field-1"
                                    containerClassName="display-inline-block"
                                    name="A_Klasse6"
                                    id="A_Klasse6"
                                    value={this.state.A_Klasse6}
                                    maxLength="5"
                                    options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{0,5}"}]}
                                    autoCheckErrors={true}
                                    required={false}
                                    hideErrWhenFocused={true}
                                    hideErrUntilFocused={true}
                                    onChange={this.onStandardFieldChange}
                                    ref={instance => { this.fields[6] = instance; }}
                                />
                                : <span className="value-text">{this.props.isClub ? this.props.admin.generalSection.Indskud.A_Klasse6 : this.state.A_Klasse6}</span>}
                        </td>
                    </tr>
                    {this.props.isClub ?
                        <tr className="normal-row">
                            <td className={"label-cell"}><span className="label-text">Sektion</span></td>
                            <td className={"data-cell"}><span className="value-text">{this.props.section.Sektion.Indskud === null ? 0 : this.props.section.Sektion.Indskud.A_Klasse1}</span></td>
                            <td className={"data-cell"}><span className="value-text">{this.props.section.Sektion.Indskud === null ? 0 : this.props.section.Sektion.Indskud.A_Klasse2}</span></td>
                            <td className={"data-cell"}><span className="value-text">{this.props.section.Sektion.Indskud === null ? 0 : this.props.section.Sektion.Indskud.A_Klasse3}</span></td>
                            <td className={"data-cell"}><span className="value-text">{this.props.section.Sektion.Indskud === null ? 0 : this.props.section.Sektion.Indskud.A_Klasse4}</span></td>
                            <td className={"data-cell"}><span className="value-text">{this.props.section.Sektion.Indskud === null ? 0 : this.props.section.Sektion.Indskud.A_Klasse5}</span></td>
                            <td className={"data-cell"}><span className="value-text">{this.props.section.Sektion.Indskud === null ? 0 : this.props.section.Sektion.Indskud.A_Klasse6}</span></td>
                        </tr>
                        : null
                    }

                    <tr>
                        {this.props.isClub ? <td className={"label-cell"}><span className="label-text"><label htmlFor="A_Klasse1">&nbsp;</label></span></td> : null}
                        <td className={"label-cell"}><span className="label-text"><label htmlFor="KL_P">Kl. P</label></span></td>
                        <td className={"label-cell"}><span className="label-text"><label htmlFor="KL_E">Kl. E</label></span></td>
                        <td className={"label-cell"}><span className="label-text"><label htmlFor="Slagspil">Slagspil</label></span></td>
                        <td className={"label-cell"}><span className="label-text"><label htmlFor="KL_Z">Kl. Z</label></span></td>
                        <td className={"label-cell"}><span className="label-text"><label htmlFor="KL_R">DM</label></span></td>
                    </tr>
                    <tr className={this.props.isClub ? "" : "normal-row"}>
                        {this.props.isClub ? <td className={"label-cell"}><span className="label-text">DdB</span></td> : null}
                        <td className={"data-cell"}>
                            {editMode && !this.props.isClub ?
                                <UserFieldElement
                                    dataType={UserFieldDataType.regex}
                                    placeholder=""
                                    className="field-1 "
                                    containerClassName="display-inline-block"
                                    name="KL_P"
                                    id="KL_P"
                                    value={this.state.KL_P}
                                    maxLength="5"
                                    options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{0,5}"}]}
                                    autoCheckErrors={true}
                                    required={false}
                                    hideErrWhenFocused={true}
                                    hideErrUntilFocused={true}
                                    onChange={this.onStandardFieldChange}
                                    ref={instance => { this.fields[7] = instance; }}
                                />
                                : <span className="value-text">{this.props.isClub ? this.props.admin.generalSection.Indskud.KL_P : this.state.KL_P}</span>}
                        </td>
                        <td className={"data-cell"}>
                            {editMode && !this.props.isClub ?
                                <UserFieldElement
                                    dataType={UserFieldDataType.regex}
                                    placeholder=""
                                    className="field-1 "
                                    containerClassName="display-inline-block"
                                    name="KL_E"
                                    id="KL_E"
                                    value={this.state.KL_E}
                                    maxLength="5"
                                    options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{0,5}"}]}
                                    autoCheckErrors={true}
                                    required={false}
                                    hideErrWhenFocused={true}
                                    hideErrUntilFocused={true}
                                    onChange={this.onStandardFieldChange}
                                    ref={instance => { this.fields[8] = instance; }}
                                />
                                : <span className="value-text">{this.props.isClub ? this.props.admin.generalSection.Indskud.KL_E : this.state.KL_E}</span>}
                        </td>
                        <td className={"data-cell"}>
                            {editMode && !this.props.isClub ?
                                <UserFieldElement
                                    dataType={UserFieldDataType.regex}
                                    placeholder=""
                                    className="field-1 "
                                    containerClassName="display-inline-block"
                                    name="Slagspil"
                                    id="Slagspil"
                                    value={this.state.Slagspil}
                                    maxLength="5"
                                    options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{0,5}"}]}
                                    autoCheckErrors={true}
                                    required={false}
                                    hideErrWhenFocused={true}
                                    hideErrUntilFocused={true}
                                    onChange={this.onStandardFieldChange}
                                    ref={instance => { this.fields[9] = instance; }}
                                />
                                : <span className="value-text">{this.props.isClub ? this.props.admin.generalSection.Indskud.Slagspil : this.state.Slagspil}</span>}
                        </td>
                        <td className={"data-cell"}>
                            {editMode && !this.props.isClub ?
                                <UserFieldElement
                                    dataType={UserFieldDataType.regex}
                                    placeholder=""
                                    className="field-1 "
                                    containerClassName="display-inline-block"
                                    name="KL_Z"
                                    id="KL_Z"
                                    value={this.state.KL_Z}
                                    maxLength="5"
                                    options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{0,5}"}]}
                                    autoCheckErrors={true}
                                    required={false}
                                    hideErrWhenFocused={true}
                                    hideErrUntilFocused={true}
                                    onChange={this.onStandardFieldChange}
                                    ref={instance => { this.fields[10] = instance; }}
                                />
                                : <span className="value-text">{this.props.isClub ? this.props.admin.generalSection.Indskud.KL_Z : this.state.KL_Z}</span>}
                        </td>
                        <td className={"data-cell"}>
                            {editMode && !this.props.isClub ?
                                <UserFieldElement
                                    dataType={UserFieldDataType.regex}
                                    placeholder=""
                                    className="field-1 "
                                    containerClassName="display-inline-block"
                                    name="KL_R"
                                    id="KL_R"
                                    value={this.state.KL_R}
                                    maxLength="5"
                                    options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{0,5}"}]}
                                    autoCheckErrors={true}
                                    required={false}
                                    hideErrWhenFocused={true}
                                    hideErrUntilFocused={true}
                                    onChange={this.onStandardFieldChange}
                                    ref={instance => { this.fields[11] = instance; }}
                                />
                                : <span className="value-text">{this.props.isClub ? this.props.admin.generalSection.Indskud.KL_R : this.state.KL_R}</span>}
                        </td>
                    </tr>
                    {this.props.isClub ?
                        <tr className="normal-row">
                            <td className={"label-cell"}><span className="label-text">Sektion</span></td>
                            <td className={"data-cell"}><span className="value-text">{this.props.section.Sektion.Indskud === null ? 0 : this.props.section.Sektion.Indskud.KL_P}</span></td>
                            <td className={"data-cell"}><span className="value-text">{this.props.section.Sektion.Indskud === null ? 0 : this.props.section.Sektion.Indskud.KL_E}</span></td>
                            <td className={"data-cell"}><span className="value-text">{this.props.section.Sektion.Indskud === null ? 0 : this.props.section.Sektion.Indskud.Slagspil}</span></td>
                            <td className={"data-cell"}><span className="value-text">{this.props.section.Sektion.Indskud === null ? 0 : this.props.section.Sektion.Indskud.KL_Z}</span></td>
                            <td className={"data-cell"}><span className="value-text">{this.props.section.Sektion.Indskud === null ? 0 : this.props.section.Sektion.Indskud.KL_R}</span></td>
                        </tr>
                        : null
                    }
                </tbody>
            </table>

            <table className="main-form-table deposit-table">
                <tbody>
                    <tr>
                        <td className={"label-cell"}><span className="label-text"><label className={"deposit-header"}>B-Spil</label></span></td>
                    </tr>
                    <tr>
                        {this.props.isClub ? <td className={"label-cell"}><span className="label-text"><label htmlFor="A_Klasse1">&nbsp;</label></span></td> : null}
                        <td className={"label-cell"}><span className="label-text"><label htmlFor="B_Klasse1">Kl. 1</label></span></td>
                        <td className={"label-cell"}><span className="label-text"><label htmlFor="B_Klasse2">Kl. 2</label></span></td>
                        <td className={"label-cell"}><span className="label-text"><label htmlFor="B_Klasse3">Kl. 3</label></span></td>
                        <td className={"label-cell"}><span className="label-text"><label htmlFor="B_Klasse4">Kl. 4</label></span></td>
                        <td className={"label-cell"}><span className="label-text"><label htmlFor="B_Klasse5">Kl. 5</label></span></td>
                        <td className={"label-cell"}><span className="label-text"><label htmlFor="B_Klasse6">Kl. 6</label></span></td>
                    </tr>
                    <tr className={this.props.isClub ? "" : "normal-row"}>
                        {this.props.isClub ? <td className={"label-cell"}><span className="label-text">DdB</span></td> : null}
                        <td className={"data-cell"}>
                            {editMode && !this.props.isClub ?
                                <UserFieldElement
                                    dataType={UserFieldDataType.regex}
                                    placeholder=""
                                    className="field-1 "
                                    containerClassName="display-inline-block"
                                    name="B_Klasse1"
                                    id="B_Klasse1"
                                    value={this.state.B_Klasse1}
                                    maxLength="5"
                                    options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{0,5}"}]}
                                    autoCheckErrors={true}
                                    required={false}
                                    hideErrWhenFocused={true}
                                    hideErrUntilFocused={true}
                                    onChange={this.onStandardFieldChange}
                                    ref={instance => { this.fields[12] = instance; }}
                                />
                                : <span className="value-text">{this.props.isClub ? this.props.admin.generalSection.Indskud.B_Klasse1 : this.state.B_Klasse1}</span>}
                        </td>
                        <td className={"data-cell"}>
                            {editMode && !this.props.isClub ?
                                <UserFieldElement
                                    dataType={UserFieldDataType.regex}
                                    placeholder=""
                                    className="field-1 "
                                    containerClassName="display-inline-block"
                                    name="B_Klasse2"
                                    id="B_Klasse2"
                                    value={this.state.B_Klasse2}
                                    maxLength="5"
                                    options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{0,5}"}]}
                                    autoCheckErrors={true}
                                    required={false}
                                    hideErrWhenFocused={true}
                                    hideErrUntilFocused={true}
                                    onChange={this.onStandardFieldChange}
                                    ref={instance => { this.fields[13] = instance; }}
                                />
                                : <span className="value-text">{this.props.isClub ? this.props.admin.generalSection.Indskud.B_Klasse2 : this.state.B_Klasse2}</span>}
                        </td>
                        <td className={"data-cell"}>
                            {editMode && !this.props.isClub ?
                                <UserFieldElement
                                    dataType={UserFieldDataType.regex}
                                    placeholder=""
                                    className="field-1 "
                                    containerClassName="display-inline-block"
                                    name="B_Klasse3"
                                    id="B_Klasse3"
                                    value={this.state.B_Klasse3}
                                    maxLength="5"
                                    options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{0,5}"}]}
                                    autoCheckErrors={true}
                                    required={false}
                                    hideErrWhenFocused={true}
                                    hideErrUntilFocused={true}
                                    onChange={this.onStandardFieldChange}
                                    ref={instance => { this.fields[14] = instance; }}
                                />
                                : <span className="value-text">{this.props.isClub ? this.props.admin.generalSection.Indskud.B_Klasse3 : this.state.B_Klasse3}</span>}
                        </td>
                        <td className={"data-cell"}>
                            {editMode && !this.props.isClub ?
                                <UserFieldElement
                                    dataType={UserFieldDataType.regex}
                                    placeholder=""
                                    className="field-1 "
                                    containerClassName="display-inline-block"
                                    name="B_Klasse4"
                                    id="B_Klasse4"
                                    value={this.state.B_Klasse4}
                                    maxLength="5"
                                    options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{0,5}"}]}
                                    autoCheckErrors={true}
                                    required={false}
                                    hideErrWhenFocused={true}
                                    hideErrUntilFocused={true}
                                    onChange={this.onStandardFieldChange}
                                    ref={instance => { this.fields[15] = instance; }}
                                />
                                : <span className="value-text">{this.props.isClub ? this.props.admin.generalSection.Indskud.B_Klasse4 : this.state.B_Klasse4}</span>}
                        </td>
                        <td className={"data-cell"}>
                            {editMode && !this.props.isClub ?
                                <UserFieldElement
                                    dataType={UserFieldDataType.regex}
                                    placeholder=""
                                    className="field-1 "
                                    containerClassName="display-inline-block"
                                    name="B_Klasse5"
                                    id="B_Klasse5"
                                    value={this.state.B_Klasse5}
                                    maxLength="5"
                                    options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{0,5}"}]}
                                    autoCheckErrors={true}
                                    required={false}
                                    hideErrWhenFocused={true}
                                    hideErrUntilFocused={true}
                                    onChange={this.onStandardFieldChange}
                                    ref={instance => { this.fields[16] = instance; }}
                                />
                                : <span className="value-text">{this.props.isClub ? this.props.admin.generalSection.Indskud.B_Klasse5 : this.state.B_Klasse5}</span>}
                        </td>
                        <td className={"data-cell"}>
                            {editMode && !this.props.isClub ?
                                <UserFieldElement
                                    dataType={UserFieldDataType.regex}
                                    placeholder=""
                                    className="field-1 "
                                    containerClassName="display-inline-block"
                                    name="B_Klasse6"
                                    id="B_Klasse6"
                                    value={this.state.B_Klasse6}
                                    maxLength="5"
                                    options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{0,5}"}]}
                                    autoCheckErrors={true}
                                    required={false}
                                    hideErrWhenFocused={true}
                                    hideErrUntilFocused={true}
                                    onChange={this.onStandardFieldChange}
                                    ref={instance => { this.fields[17] = instance; }}
                                />
                                : <span className="value-text">{this.props.isClub ? this.props.admin.generalSection.Indskud.B_Klasse6 : this.state.B_Klasse6}</span>}
                        </td>
                    </tr>
                    {this.props.isClub ?
                        <tr className="normal-row">
                            <td className={"label-cell"}><span className="label-text">Sektion</span></td>
                            <td className={"data-cell"}><span className="value-text">{this.props.section.Sektion.Indskud === null ? 0 : this.props.section.Sektion.Indskud.B_Klasse1}</span></td>
                            <td className={"data-cell"}><span className="value-text">{this.props.section.Sektion.Indskud === null ? 0 : this.props.section.Sektion.Indskud.B_Klasse2}</span></td>
                            <td className={"data-cell"}><span className="value-text">{this.props.section.Sektion.Indskud === null ? 0 : this.props.section.Sektion.Indskud.B_Klasse3}</span></td>
                            <td className={"data-cell"}><span className="value-text">{this.props.section.Sektion.Indskud === null ? 0 : this.props.section.Sektion.Indskud.B_Klasse4}</span></td>
                            <td className={"data-cell"}><span className="value-text">{this.props.section.Sektion.Indskud === null ? 0 : this.props.section.Sektion.Indskud.B_Klasse5}</span></td>
                            <td className={"data-cell"}><span className="value-text">{this.props.section.Sektion.Indskud === null ? 0 : this.props.section.Sektion.Indskud.B_Klasse6}</span></td>
                        </tr>
                        : null
                    }
                    {this.props.isDDB ?
                        <React.Fragment>
                            <tr>
                                <td className={"label-cell"}><span className="label-text"><label htmlFor="Derby">Derby</label></span></td>
                            </tr>
                            <tr className="normal-row">
                                <td className={"data-cell"}>
                                    {editMode ?
                                        <UserFieldElement
                                            dataType={UserFieldDataType.regex}
                                            placeholder=""
                                            className="field-1"
                                            containerClassName="display-inline-block"
                                            name="Derby"
                                            id="Derby"
                                            value={this.state.Derby}
                                            maxLength="5"
                                            options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{0,5}"}]}
                                            autoCheckErrors={true}
                                            required={false}
                                            hideErrWhenFocused={true}
                                            hideErrUntilFocused={true}
                                            onChange={this.onStandardFieldChange}
                                            ref={instance => { this.fields[18] = instance; }}
                                        />
                                        : <span className="value-text">{this.state.Derby}</span>}
                                </td>
                            </tr>
                        </React.Fragment>
                    : this.props.isClub ?
                        <React.Fragment>
                            <tr>
                                <td colSpan={3} className={"label-cell"}><span className="label-text"><label htmlFor="TillaegPrDueForening">Tillæg pr. due i øre</label></span></td>
                                <td colSpan={3} className={"label-cell"}><span className="label-text"><label htmlFor="TillaegFastForening">Fast tillæg i øre</label></span></td>
                            </tr>
                            <tr>
                                <td colSpan={3} className={"data-cell"}>
                                    {editMode ?
                                        <UserFieldElement
                                            dataType={UserFieldDataType.regex}
                                            placeholder=""
                                            className="field-1"
                                            containerClassName="display-inline-block"
                                            name="TillaegPrDueForening"
                                            id="TillaegPrDueForening"
                                            value={this.state.TillaegPrDueForening}
                                            maxLength="5"
                                            options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{0,5}"}]}
                                            autoCheckErrors={true}
                                            required={false}
                                            hideErrWhenFocused={true}
                                            hideErrUntilFocused={true}
                                            onChange={this.onStandardFieldChange}
                                            ref={instance => { this.fields[18] = instance; }}
                                        />
                                        : <span className="value-text">{this.state.TillaegPrDueForening}</span>}
                                </td>
                                <td colSpan={3} className={"data-cell"}>
                                    {editMode ?
                                        <UserFieldElement
                                            dataType={UserFieldDataType.regex}
                                            placeholder=""
                                            className="field-1"
                                            containerClassName="display-inline-block"
                                            name="TillaegFastForening"
                                            id="TillaegFastForening"
                                            value={this.state.TillaegFastForening}
                                            maxLength="5"
                                            options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{0,5}"}]}
                                            autoCheckErrors={true}
                                            required={false}
                                            hideErrWhenFocused={true}
                                            hideErrUntilFocused={true}
                                            onChange={this.onStandardFieldChange}
                                            ref={instance => { this.fields[19] = instance; }}
                                        />
                                        : <span className="value-text">{this.state.TillaegFastForening}</span>}
                                </td>
                            </tr>
                            <tr className="normal-row">
                                <td className={"data-cell"}></td>
                            </tr>
                        </React.Fragment>
                    :
                        <React.Fragment>
                            <tr>
                                <td className={"label-cell"}></td>
                            </tr>
                            <tr className="normal-row">
                                <td className={"data-cell"}></td>
                            </tr>
                        </React.Fragment>}
                </tbody>
            </table>
        </div>
        <div className={"form-page flex-center"}>
            <label className={""}>Alle indskud angives i hele kroner</label>
        </div>
        </React.Fragment>
    }
}

const mapStateToProps = (state) => ({
    admin: {
        generalSection: state.admin.generalSection
    }
});

export default connect(mapStateToProps, null, null, {withRef: true})(SettingsDeposits);




// WEBPACK FOOTER //
// ./src/client/src/components/pages/settings/subPages/SettingsDeposits.js